export function fromTimeToPixel (timesecond, timelinewidth, starttime, duration)
{

    timesecond -= starttime;
    return Math.ceil((timelinewidth * timesecond) / duration);
}

export function fromPixelToTime (pixel, timelinewidth, starttime, duration)
{

    
    return (duration /timelinewidth) * pixel;
}